/**
 * StatusTabs — Status-Reiter wie sevdesk, OHNE horizontales Scrollen:
 * Mobil die wichtigsten Reiter in einer Zeile, der Rest im „…“-Menü;
 * ab md alle Reiter sichtbar. Aktiver Reiter #E5E5E7 (DNA tab).
 */
import { MoreHorizontal, Check } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

const tabClass = (active) => cn(
  'inline-flex h-10 shrink-0 items-center gap-1 rounded-md px-2 text-[14px] font-semibold md:h-9 md:gap-1.5 md:px-2.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dna-focus',
  active ? 'bg-dna-tab text-dna-primary' : 'text-dna-muted hover:bg-dna-warm hover:text-dna-primary',
);

function Count({ n }) {
  return n === undefined ? null : <span className="text-[12px] font-medium tabular-nums text-dna-placeholder">{n}</span>;
}

/**
 * @param {{ tabs: {key: string, label: string, count?: number}[], value: string, onChange: (k: string) => void, mobileKeys: string[] }} props
 */
export default function StatusTabs({ tabs, value, onChange, mobileKeys, ariaLabel = 'Status' }) {
  const overflow = tabs.filter((t) => !mobileKeys.includes(t.key));
  const activeOverflow = overflow.find((t) => t.key === value);

  return (
    <div className="flex min-w-0 items-center gap-0.5 md:gap-1" role="tablist" aria-label={ariaLabel}>
      {tabs.map((t) => (
        <button key={t.key} type="button" role="tab" aria-selected={value === t.key} onClick={() => onChange(t.key)}
          className={cn(tabClass(value === t.key), !mobileKeys.includes(t.key) && 'hidden md:inline-flex')}>
          {t.label}<Count n={t.count} />
        </button>
      ))}
      {overflow.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button type="button" aria-label={activeOverflow ? `${activeOverflow.label} (weitere Status)` : 'Weitere Status'}
              className={cn(tabClass(!!activeOverflow), 'md:hidden')}>
              {activeOverflow ? <>{activeOverflow.label}<Count n={activeOverflow.count} /></> : <MoreHorizontal className="h-4 w-4" />}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-48 rounded-lg border-dna-line p-1 shadow-[0_4px_12px_rgba(34,34,67,0.08)]">
            {overflow.map((t) => (
              <DropdownMenuItem key={t.key} onClick={() => onChange(t.key)}
                className={cn('h-10 justify-between rounded-md text-[14px] font-semibold text-dna-primary', value === t.key && 'ring-2 ring-inset ring-dna-focus')}>
                <span className="flex items-center gap-1.5">{t.label}<Count n={t.count} /></span>
                {value === t.key && <Check className="h-4 w-4" />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
